export default __webpack_public_path__ + "static/media/photo-content-2.c282ab44.png";